module.exports = __webpack_public_path__ + "static/instagram-5be6ee4be4b6d62fd8cb6b2e8e1f65fe.png";